"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcFunction = calcFunction;
exports.calcFunctionOld = calcFunctionOld;
const defineSchema_1 = require("./defineSchema");
const fix_parent_1 = __importDefault(require("./fix$parent"));
const funcParams_1 = __importDefault(require("./funcParams"));
const schemaPath_1 = __importDefault(require("./schemaPath"));
const cacheFuncs = {};
/**
 * tworzy funkcję obliczającą na podstawie schematu
 * @param schema schemat
 * @param cache czy używać cache
 * @param debug czy dodać debugger, wtedy każde wywołanie funkcji się zatrzymuje
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function calcFunction(schema, cache, debug, useStrict) {
    let func = null;
    const calc = schema.calc;
    if (calc) {
        if ((0, defineSchema_1.isFunction)(calc)) {
            return calc;
        }
        if (schema.__cache && schema.__cache.calcFunc) {
            return schema.__cache.calcFunc;
        }
        let funcText = schema.calc;
        // const cacheKey = funcText;
        let when = '';
        let ftext = '';
        let stext = '';
        if (calc.func) {
            funcText = calc.func;
            when = calc.when;
        }
        let cacheKey = '';
        if (cache && !debug) {
            cacheKey =
                'calc' +
                    (when ? `||when:${when}` : '') +
                    `||type:${schema.type}` +
                    (schema.precision ? `||prec:${schema.precision}` : '') +
                    `||text:${funcText}`;
            func = cacheFuncs[cacheKey];
            if (func !== undefined) {
                if (schema.__cache === undefined) {
                    Object.defineProperty(schema, '__cache', {
                        value: {}
                    });
                }
                Object.defineProperty(schema.__cache, 'calcFunc', {
                    value: func
                });
                return func;
            }
        }
        if (Array.isArray(funcText)) {
            funcText = funcText.join('\r\n');
            // jednak nie zamieniam return, przyda się do undefined
            /*
                  if (funcText.indexOf("return ") === -1) {
                      funcText = "var $result;\r\n" + funcText;
      
                  } else {
                      funcText = funcText.replace("return ", "var $result = ");
                  }
                  */
            // funcText = 'var $result;\r\n' + funcText;
            stext = (0, fix_parent_1.default)(funcText);
            ftext = stext + '\r\n';
            //stext = '$result';
        }
        else {
            stext = (0, fix_parent_1.default)(funcText);
            if (debug) {
                // ftext += `var $result = (${stext});\r\n`;
            }
        }
        //(!(/(return[\s\"\!\'\(\;]|return$)/)
        //if (stext.indexOf('return ') == -1) {
        // eslint-disable-next-line no-useless-escape
        if (!/(return[\s\"\!\'\(\;]|return$)/.test(stext)) {
            if (stext.indexOf('$result') == -1) {
                ftext = `return (${stext});`;
            }
            else {
                ftext = `var $result;\r\n${stext}\r\nreturn $result;`;
            }
        }
        if (debug) {
            // ftext += `var result = (${stext});\r\n`;
            if (when) {
                ftext = `if (${(0, fix_parent_1.default)(when)}) { // when: ${when}\r\n\r\n${ftext}\r\n}`;
            }
            else {
                // ftext += 'return $result;';
            }
            // schemaPath
            // ftext = 'console.debug($obj.$path);\r\ndebugger;\r\n' + ftext;
            ftext = `\r\n/*** ${(0, schemaPath_1.default)(schema, true)} calc debug ***/\r\nconsole.debug('calc: '+$obj.$path); // model path\r\ndebugger;\r\n\r\n/*** function body ***/\r\n${ftext}`;
            // ftext = `"${schemaPath(schema, true)}";\r\nconsole.debug($obj.$path);\r\ndebugger;\r\n${ftext}`;
            // ftext = '"' + schemaPath(schema, true) + '";\r\nconsole.debug($obj.$path);\r\ndebugger;\r\n' + ftext;
        }
        else {
            if (when) {
                ftext = `if (${(0, fix_parent_1.default)(when)}) {\r\n  ${ftext}}`;
            }
        }
        // nie może być use strict bo podajemy parametry spredem
        /*
        if (useStrict || process.env.NODE_ENV !== 'production') {
          ftext = '"use strict";\r\n' + ftext;
        }
        */
        //func = new Function(funcParams, ftext);
        //spred
        func = new Function('{' + funcParams_1.default + '}', ftext);
        if (cacheKey) {
            cacheFuncs[cacheKey] = func;
            if (schema.__cache === undefined) {
                Object.defineProperty(schema, '__cache', {
                    value: {}
                });
            }
            schema.__cache.calcFunc = func;
        }
    }
    return func;
}
/**
 * tworzy funkcję obliczającą na podstawie schematu
 * @param schema schemat
 * @param cache czy używać cache
 * @param debug czy dodać debugger, wtedy każde wywołanie funkcji się zatrzymuje
 */
function calcFunctionOld(schema, cache = true, debug, useStrict) {
    let func = null;
    const calc = schema.calc;
    if (calc) {
        if (schema._calcFunc) {
            return schema._calcFunc;
        }
        let funcText = schema.calc;
        // const cacheKey = funcText;
        let when = '';
        let ftext = '';
        let stext = '';
        if (calc.func) {
            funcText = calc.func;
            when = calc.when;
        }
        let cacheKey = '';
        if (cache && !debug) {
            cacheKey =
                'calc' +
                    (when ? `||when:${when}` : '') +
                    `||type:${schema.type}` +
                    (schema.precision ? `||prec:${schema.precision}` : '') +
                    `||text:${funcText}`;
            func = cacheFuncs[cacheKey];
            if (func !== undefined) {
                Object.defineProperty(schema, '_calcFunc', {
                    value: func
                });
                return func;
            }
        }
        if (Array.isArray(funcText)) {
            funcText = funcText.join('\r\n');
            // jednak nie zamieniam return, przyda się do undefined
            /*
                  if (funcText.indexOf("return ") === -1) {
                      funcText = "var $result;\r\n" + funcText;
      
                  } else {
                      funcText = funcText.replace("return ", "var $result = ");
                  }
                  */
            funcText = 'var $result;\r\n' + funcText;
            stext = (0, fix_parent_1.default)(funcText);
            ftext = stext + '\r\n';
            stext = '$result';
        }
        else {
            stext = (0, fix_parent_1.default)(funcText);
            if (debug) {
                ftext += `var $result = (${stext});\r\n`;
            }
        }
        if (debug) {
            // ftext += `var result = (${stext});\r\n`;
            switch (schema.type) {
                case 'integer':
                    ftext += '/*** round to integer ***/\r\n';
                    ftext += `$result = $methods.mround($result,0);\r\n`;
                    break;
                // case 'money': ftext += 'return Math.round($result);'; break;
                case 'money':
                    if (schema.precision !== undefined) {
                        ftext += '/*** round to ' + schema.precision + ' digits ***/\r\n';
                        ftext += `$result = $methods.mround($result,${schema.precision});\r\n`;
                    }
                    else {
                        ftext += '/*** round to money ***/\r\n';
                        ftext += `$result = $methods.mround($result,2);\r\n`;
                    }
                    break;
                case 'number':
                    if (schema.precision !== undefined) {
                        ftext += '/*** round to ' + schema.precision + ' digits ***/\r\n';
                        ftext += `$result = $methods.mround($result,${schema.precision});\r\n`;
                    }
                    else {
                        // ftext += `return result;`;
                    }
                    break;
                case 'object':
                    {
                        // deep copy, żeby reagował na kazdą zmianę pola
                        ftext += '/*** deep copy to object ***/\r\n';
                        // ftext += `$result = $methods.deepCopy($result);\r\n`;
                        const keys = Object.keys(schema.properties || {});
                        ftext +=
                            '$result = !$result ? null : {' +
                                keys
                                    .map((x) => (schema.properties || {})[x].type === 'array' || (schema.properties || {})[x].type === 'object'
                                    ? x + ': $result.' + x + '===undefined ? undefined : $methods.deepCopy($result.' + x + ')'
                                    : x + ': $result.' + x)
                                    .join(', ') +
                                '}';
                        ftext += '\r\n';
                    }
                    break;
                default:
                    // ftext += `return result;`;
                    break;
            }
            if (when) {
                ftext = `if (${(0, fix_parent_1.default)(when)}) { // when: ${when}\r\n\r\n${ftext}return $result;\r\n\r\n}`;
            }
            else {
                ftext += 'return $result;';
            }
            // schemaPath
            // ftext = 'console.debug($obj.$path);\r\ndebugger;\r\n' + ftext;
            ftext = `\r\n/*** ${(0, schemaPath_1.default)(schema, true)} calc debug ***/\r\nconsole.debug('calc: '+$obj.$path); // model path\r\ndebugger;\r\n\r\n/*** function body ***/\r\n${ftext}`;
            // ftext = `"${schemaPath(schema, true)}";\r\nconsole.debug($obj.$path);\r\ndebugger;\r\n${ftext}`;
            // ftext = '"' + schemaPath(schema, true) + '";\r\nconsole.debug($obj.$path);\r\ndebugger;\r\n' + ftext;
        }
        else {
            switch (schema.type) {
                case 'integer':
                    ftext += `return $methods.mround((${stext}),0);\r\n`;
                    break;
                // case 'money': ftext += 'return Math.round($result);'; break;
                case 'money':
                    if (schema.precision !== undefined) {
                        ftext += `return $methods.mround((${stext}),${schema.precision});\r\n`;
                    }
                    else {
                        ftext += `return $methods.mround((${stext}),2);\r\n`;
                    }
                    break;
                case 'number':
                    if (schema.precision !== undefined) {
                        ftext += `return $methods.mround((${stext}),${schema.precision});\r\n`;
                    }
                    else {
                        ftext += `return (${stext});`;
                    }
                    break;
                case 'object':
                    {
                        // deep copy, żeby reagował na kazdą zmianę pola
                        // ftext += `return $methods.deepCopy(${stext});`;
                        const keys = Object.keys(schema.properties || {});
                        ftext +=
                            'var $result=(' +
                                stext +
                                '); return !$result ? null : {' +
                                keys
                                    .map((x) => (schema.properties || {})[x].type === 'array' || (schema.properties || {})[x].type === 'object'
                                    ? x + ': $result.' + x + '===undefined ? undefined : $methods.deepCopy($result.' + x + ')'
                                    : x + ': $result.' + x)
                                    .join(', ') +
                                '}';
                    }
                    break;
                default:
                    ftext += `return (${stext});`;
                    break;
            }
            if (when) {
                ftext = `if (${(0, fix_parent_1.default)(when)}) {\r\n  ${ftext}}`;
            }
        }
        if (useStrict || process.env.NODE_ENV !== 'production') {
            ftext = '"use strict";\r\n' + ftext;
        }
        func = new Function(funcParams_1.default, ftext);
        if (cacheKey) {
            cacheFuncs[cacheKey] = func;
            Object.defineProperty(schema, '_calcFunc', {
                value: func
            });
        }
    }
    return func;
}
exports.default = calcFunction;
//# sourceMappingURL=calcFunction.js.map